const CANVASEXPRESS_PUBLIC_BASE_URL = 'https://storage.googleapis.com/canvasexpress'

export const getCanvasExpressMediaUrl = (path) => `${CANVASEXPRESS_PUBLIC_BASE_URL}/${path}`

export const getProductImageUrl = (image, product = {}, fallback = '') => {
    if (!image) { return fallback }
    if (image.path) { return getCanvasExpressMediaUrl(image.path) }

    return fallback
}

export const getProductPrimaryImageUrl = (product, fallback = '') => (
    getProductImageUrl(product?.images?.[0], product, fallback)
)

export const getVariantImageUrl = (variant, product, fallback = '') => {
    if (variant?.imagePath) return getCanvasExpressMediaUrl(variant.imagePath)

    return fallback
}
